module.exports = __webpack_public_path__ + "static/media/lupa.aeefa637.svg";